import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getWinnersLottery = (params) => {
    return axios.get(`${backendHost}/api/admin/lottery/winners`, {params});
};

export {
    getWinnersLottery
}